export default {
	title: '特征值定义',
	actions: {
		add: '新增',
		edit: '修改',
		delete: '删除',
		batchDelete: '批量删除'
	},
	messages: {
		deleteConfirm: '确定删除选中的 {count} 项记录吗？',
		deleteSuccess: '操作成功',
		selectDeleteWarning: '请选择要删除的记录',
		operateSuccess: '操作成功',
		requiredFieldCannotBeEmpty: '必填项不能为空'
	},
	form: {
		name: '特征值名称',
		unit: '单位',
		nickname: '英文名',
		placeholder: {
			name: '请输入特征值名称',
			unit: '请输入单位',
			nickname: '请输入英文名'
		}
	},
	table: {
		id: 'ID',
		name: '特征值名称',
		unit: '特征值单位',
		nickname: '英文名称',
		dimension: '数据维度',
		remark: '备注',
		sort: '排序'
	},
	dialog: {
		add: '新增',
		edit: '修改',
		cancel: '取消',
		confirm: '确定'
	},
	widgetForm: {
		name: '特征值名称',
		unit: '单位',
		nickname: '英文名',
		dimension: '数据维度',
		sort: '排序',
		remark: '备注',
		gridLayout: '格栅布局',
		requiredFieldCannotBeEmpty: '必填项不能为空',
		placeholder: {
			name: '请输入特征值名称',
			unit: '请输入单位',
			nickname: '请输入英文名'
		}
	},
	dimension: {
		value1: '标签 1',
		value2: '标签 2',
		value3: '标签 3'
	}
}
